module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/logo_gifu-43fdef4525d27fe715f60a314b53f578.png";